import * as React from 'react';
import './SpinnerCss.styles.less';
import { ISpinnerCssProps } from "./SpinnerCss.types";

export const SpinnerCss = (props: ISpinnerCssProps) =>
    <div className="spinner-circle" />;
